import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import { useState } from 'react';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

function mapObject(source, mapper) {
  var target = {};

  for (var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        _key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    var newValue = mapper(_key, value);
    target[_key] = newValue;
  }

  return target;
}

var emptyFn = function emptyFn() {};

function getScalarFieldInstance(field, state, setState, validationResult) {
  return _objectSpread(_objectSpread({}, validationResult), {}, {
    state: state,
    props: field.props(_objectSpread({
      onBlur: function onBlur() {
        return setState(function (prevState) {
          if (prevState.touched) {
            return prevState;
          }

          return {
            value: prevState.value,
            touched: true
          };
        });
      },
      onChange: function onChange(value) {
        setState(function (prevState) {
          if (prevState.value === value) {
            return prevState;
          }

          return {
            value: value,
            touched: prevState.touched
          };
        });
      },
      onFocus: emptyFn,
      touched: state.touched
    }, validationResult)),
    setState: function (_setState) {
      function setState(_x) {
        return _setState.apply(this, arguments);
      }

      setState.toString = function () {
        return _setState.toString();
      };

      return setState;
    }(function (stateUpdate) {
      if (typeof stateUpdate === "function") {
        // @ts-ignore
        setState(stateUpdate);
      } else {
        setState(function () {
          return stateUpdate;
        });
      }
    }),
    _field: field
  });
}
function scalar(scalarFieldOptions) {
  return function (options) {
    return {
      kind: "scalar",
      initialValue: scalarFieldOptions.initialValue,
      stateFromChange: options === null || options === void 0 ? void 0 : options.stateFromChange,
      props: scalarFieldOptions.props,
      // @ts-ignore
      validate: (options === null || options === void 0 ? void 0 : options.validate) || function (value) {
        return {
          validity: "valid",
          value: value
        };
      }
    };
  };
}

function getFieldValidity(field, validationResult) {
  if (field.kind === "scalar") {
    return validationResult.validity;
  }

  if (field.kind === "array") {
    return validationResult.every(function (validationResultElement) {
      return getFieldValidity(field.element, validationResultElement) === "valid";
    }) ? "valid" : "invalid";
  }

  return Object.keys(field.fields).every(function (key) {
    return getFieldValidity(field.fields[key], validationResult[key]) === "valid";
  }) ? "valid" : "invalid";
}
function getObjectFieldInstance(field, state, setState, validationResult) {
  var fields = {};
  Object.keys(field.fields).forEach(function (key) {
    fields[key] = getFieldInstance(field.fields[key], state[key], function (thing) {
      setState(function (prevState) {
        var newInnerState = thing(prevState[key]);
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, key, newInnerState));
      });
    }, validationResult[key]);
  });
  return {
    fields: fields,
    state: state,
    setState: function (_setState) {
      function setState(_x) {
        return _setState.apply(this, arguments);
      }

      setState.toString = function () {
        return _setState.toString();
      };

      return setState;
    }(function (partial) {
      setState(function (prevState) {
        var newState = _objectSpread({}, prevState);

        Object.keys(partial).forEach(function (key) {
          if (partial[key] !== undefined) {
            newState[key] = partial[key];
          }
        });
        return newState;
      });
    }),
    validity: getFieldValidity(field, validationResult),
    value: getValueFromState(field, state),
    _field: field
  };
}
function object(fields, options) {
  return {
    kind: "object",
    fields: fields,
    validate: options === null || options === void 0 ? void 0 : options.validate,
    stateFromChange: options === null || options === void 0 ? void 0 : options.stateFromChange
  };
}

function getArrayFieldInstance(field, state, setState, validationResult) {
  var elements = state.map(function (stateElement, i) {
    return getFieldInstance(field.element, stateElement, function (thing) {
      setState(function (prevState) {
        var newVal = _toConsumableArray(prevState);

        newVal[i] = thing(newVal[i]);
        return newVal;
      });
    }, validationResult[i]);
  });
  return {
    elements: elements,
    state: state,
    setState: function (_setState) {
      function setState(_x) {
        return _setState.apply(this, arguments);
      }

      setState.toString = function () {
        return _setState.toString();
      };

      return setState;
    }(function (elements) {
      setState(function () {
        return elements;
      });
    }),
    validity: getFieldValidity(field, validationResult),
    value: getValueFromState(field, state),
    _field: field
  };
}
function array(element, options) {
  return {
    kind: "array",
    element: element,
    validate: options === null || options === void 0 ? void 0 : options.validate,
    stateFromChange: options === null || options === void 0 ? void 0 : options.stateFromChange
  };
}

function getValueFromState(field, state) {
  if (field.kind === "scalar") {
    return state.value;
  }

  if (field.kind === "array") {
    return state.map(function (x) {
      return getValueFromState(field.element, x);
    });
  }

  var obj = {};
  Object.keys(field.fields).forEach(function (key) {
    obj[key] = getValueFromState(field.fields[key], state[key]);
  });
  return obj;
}
function getFieldInstance(field, state, setState, validationResult) {
  if (field.kind === "scalar") {
    return getScalarFieldInstance(field, state, setState, validationResult);
  }

  if (field.kind === "array") {
    return getArrayFieldInstance(field, state, setState, validationResult);
  }

  return getObjectFieldInstance(field, state, setState, validationResult);
}

var validation = {
  valid: function valid(value) {
    return {
      validity: "valid",
      value: value
    };
  },
  invalid: function invalid(error) {
    return {
      validity: "invalid",
      error: error
    };
  }
};

function runValidationFunction(validationFn, value) {
  var result = validationFn(value);

  if (result.validity === "valid") {
    return {
      validity: "valid",
      value: result.value,
      error: undefined
    };
  }

  return {
    validity: "invalid",
    value: value,
    error: result.error
  };
}

function getInitialState(rootField) {
  // @ts-ignore
  return getInitialValueFromField(rootField, arguments.length <= 1 ? undefined : arguments[1]);
}

function getInitialValueFromField(field, initialValue) {
  if (field.kind === "object") {
    if (initialValue === undefined) {
      initialValue = {};
    }

    return mapObject(field.fields, function (key, value) {
      return getInitialValueFromField(value, initialValue[key]);
    });
  }

  if (field.kind === "array") {
    if (initialValue === undefined) {
      initialValue = [];
    }

    return initialValue.map(function (element) {
      return getInitialValueFromField(field.element, element);
    });
  }

  return {
    touched: false,
    value: field.initialValue(initialValue)
  };
}

function getNewState(field, newState, prevState) {
  if (field.kind === "scalar") {
    if (field.stateFromChange) {
      newState = field.stateFromChange(newState, prevState);
    }

    return newState;
  }

  if (field.kind === "array") {
    var hasAElementDifferent = newState.length !== (prevState === null || prevState === void 0 ? void 0 : prevState.length);
    var newArrayState = newState.map(function (newStateElement, i) {
      var result = getNewState(field.element, newStateElement, prevState === null || prevState === void 0 ? void 0 : prevState[i]);
      hasAElementDifferent = hasAElementDifferent || result !== (prevState === null || prevState === void 0 ? void 0 : prevState[i]);
      return result;
    });

    if (field.stateFromChange) {
      var storedNewArrayState = newArrayState;
      newArrayState = field.stateFromChange(newArrayState, prevState);
      hasAElementDifferent = hasAElementDifferent || newArrayState !== storedNewArrayState;
    }

    if (hasAElementDifferent) {
      return newArrayState;
    }

    return prevState;
  }

  var newObjState = {}; // we don't want to have a new reference if we don't need to
  // TODO: maybe optimise the calling of getNewState

  var hasAFieldDifferent = false;
  mapObject(field.fields, function (key, field) {
    var result = getNewState(field, newState[key], prevState === null || prevState === void 0 ? void 0 : prevState[key]);
    hasAFieldDifferent = hasAFieldDifferent || result !== (prevState === null || prevState === void 0 ? void 0 : prevState[key]);
    newObjState[key] = result;
  });

  if (field.stateFromChange) {
    var storedNewObjState = newObjState;
    newObjState = field.stateFromChange(newObjState, prevState);
    hasAFieldDifferent = hasAFieldDifferent || newObjState !== storedNewObjState;
  }

  if (hasAFieldDifferent) {
    return newObjState;
  }

  return prevState;
}

function makeBaseValidator(field, value) {
  if (field.kind === "scalar") {
    return field.validate;
  }

  if (field.kind === "array") {
    return value.map(function (val) {
      return makeBaseValidator(field.element, val);
    });
  }

  var validationObject = {};
  Object.keys(field.fields).forEach(function (key) {
    validationObject[key] = makeBaseValidator(field.fields[key], value[key]);
  });
  return validationObject;
}

function getValidationResults(field, state) {
  var value = getValueFromState(field, state);
  var validator = makeBaseValidator(field, value);
  validator = recursivelyAddValidators(validator, field, value);
  return executeValidation(field, validator, state);
}

function executeValidation(field, validator, state) {
  if (field.kind === "object") {
    var result = {};
    Object.keys(field.fields).forEach(function (key) {
      result[key] = executeValidation(field.fields[key], validator[key], state[key]);
    });
    return result;
  }

  if (field.kind === "array") {
    return state.map(function (stateElement, i) {
      return executeValidation(field.element, validator[i], stateElement);
    });
  }

  return runValidationFunction(function (value) {
    return validator(value);
  }, state.value);
}

function recursivelyAddValidators(validator, field, value) {
  if (field.kind === "array") {
    validator = validator.map(function (innerValidator, i) {
      return recursivelyAddValidators(innerValidator, field.element, value[i]);
    });
  }

  if (field.kind === "object") {
    Object.keys(field.fields).forEach(function (key) {
      validator[key] = recursivelyAddValidators(validator[key], field.fields[key], value[key]);
    });
  }

  if (field.kind === "scalar") {
    return validator;
  }

  return addValidators(validator, field.validate, value);
}

function addValidators(inputValidator, validatorToAdd, value) {
  if (typeof inputValidator === "function" && typeof validatorToAdd === "function") {
    return function (val) {
      var inner = inputValidator(val);

      if (inner.validity === "invalid") {
        return inner;
      }

      return value === undefined ? validatorToAdd(val) : validatorToAdd(val, value);
    };
  }

  if (Array.isArray(inputValidator)) {
    return inputValidator.map(function (inputValidator) {
      return addValidators(inputValidator, validatorToAdd, value);
    });
  }

  if (_typeof(inputValidator) === "object" && _typeof(validatorToAdd) === "object") {
    Object.keys(validatorToAdd).forEach(function (key) {
      var innerInputValidator = inputValidator[key];
      var innerValidatorToAdd = validatorToAdd[key];
      inputValidator[key] = addValidators(innerInputValidator, innerValidatorToAdd, value);
    });
  }

  return inputValidator;
}

var resetForm = function resetForm(form, initialValue) {
  form.setState(getInitialValueFromField(form._field, initialValue));
};
var useForm = function useForm(rootField, initialValue) {
  var _useState = useState(function () {
    return getInitialValueFromField(rootField, initialValue);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      _setState = _useState2[1];

  var setState = function setState(newStateDescription) {
    _setState(function (prevState) {
      var newState = newStateDescription(prevState);
      return getNewState(rootField, newState, prevState);
    });
  };

  return getFieldInstance(rootField, state, setState, getValidationResults(rootField, state));
};

export { array, getArrayFieldInstance, getFieldValidity, getInitialState, getObjectFieldInstance, getScalarFieldInstance, object, resetForm, scalar, useForm, validation };
